import { CellPosition } from './cell-position.resource';
import { Broadcast } from '../broadcast.resource';
import * as moment from 'moment';

const UNAVAILABLE     = 'unavailable';
const AVAILABLE       = 'available';
const PROPAL_CHECKED  = 'propal-checked';
const PARTAVAILABLE   = 'partially-available';
const FULL_PURCHASE   = 'full-purchase';
const FULL_HYPOTHESE  = 'full-hypothese';
const FULL_HYPOTHESE_SYNCHRO = 'full-hypoth-synchro';
const FULL_HYPOTHESE_CONFIRM = 'full-hypoth-confirm';
const LINE_HYPOTHESE = 'line-hypothese';
const LINE_HYPOTHESE_SYNCHRO = 'line-hypoth-synchro';
const LINE_HYPOTHESE_CONFIRM = 'line-hypoth-confirm';

export class Cell {

  static UNAVAILABLE = UNAVAILABLE;
  static AVAILABLE = AVAILABLE;
  static PROPAL_CHECKED = PROPAL_CHECKED;
  static PARTALLY_AVAILABLE = PARTAVAILABLE;
  static FULL_PURCHASE = FULL_PURCHASE;
  static FULL_HYPOTHESE = FULL_HYPOTHESE;
  static FULL_HYPOTHESE_SYNCHRO = FULL_HYPOTHESE_SYNCHRO;
  static FULL_HYPOTHESE_CONFIRM = FULL_HYPOTHESE_CONFIRM;
  static LINE_HYPOTHESE = LINE_HYPOTHESE;
  static LINE_HYPOTHESE_SYNCHRO = LINE_HYPOTHESE_SYNCHRO;
  static LINE_HYPOTHESE_CONFIRM = LINE_HYPOTHESE_CONFIRM;

  public type: string;
  public duration: number;
  public hasGameModule: boolean;
  public position: CellPosition;
  public info: Info;
  public broadcasts: Broadcast[];
  public tooltip: PurchaseTooltip;

  public isSoReach: boolean;
  // Offer group: hypothesis on an available / partially available column, displayed as a colored line
  public hypotheseType: string;
  // Offer group: purchase of the displayed hypothesis, clickable link to the purchase
  public hypothesePurchaseId: number;
  public hypotheseLabel: string;
  public isDisable: boolean;
  public isCompletelyChecked: boolean;
  public isPartiallyChecked: boolean;

  public channelGroup: string;
  public channelImage: string;
  public programName: string;

  constructor(type) {
    this.type = type;
    this.isPartiallyChecked = false;
    this.isCompletelyChecked = false;
  }
}

export class Info {}

export class PurchaseTooltip {
  public productName: string;
  public advertiserName: string;
  public secodip: string;
  public commercialName: string;
  public expidationDate: Date;
  public alertSwitchDate: string;

  public toString(): string {
    let formatedTooltip = '';

    if (this.productName) {
      formatedTooltip = this.productName.toUpperCase() + `\n`;
    }
    if (this.advertiserName)  {
      formatedTooltip += `\n` + this.advertiserName.toUpperCase();
    }
    if (this.secodip)  {
      formatedTooltip += `\n` + this.secodip.toUpperCase();
    }
    if (this.commercialName)  {
      formatedTooltip += `\n` +  'Commercial : ' + this.commercialName.toUpperCase();
    }
    if (this.expidationDate) {
      formatedTooltip += `\n` + 'Expire le : ' + moment(this.expidationDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
    }
    if (this.alertSwitchDate) {
      formatedTooltip += `\n\n Alerte posée le ${this.alertSwitchDate}`
    }

    return formatedTooltip;
  }
}
